var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroviewHostService = exports.MicroviewSuperHostService = void 0;
var MicroViewLifecyleChannels_1 = require("@tableau/microview-communication-service/lib/src/channelDefinitions/MicroViewLifecyleChannels");
var queryString = __importStar(require("query-string"));
var axios_1 = __importDefault(require("axios"));
var Location_1 = require("./commonInfra/utils/Location");
var DOMService_1 = require("./DOMService");
var MicroViewDebugModes;
(function (MicroViewDebugModes) {
    MicroViewDebugModes[MicroViewDebugModes["none"] = 0] = "none";
    MicroViewDebugModes[MicroViewDebugModes["remote"] = 1] = "remote";
    MicroViewDebugModes[MicroViewDebugModes["local"] = 2] = "local";
})(MicroViewDebugModes || (MicroViewDebugModes = {}));
var MicroviewSuperHostService = (function () {
    function MicroviewSuperHostService() {
        this.hostServices = {};
    }
    MicroviewSuperHostService.prototype.getHostService = function (microviewName) {
        return this.hostServices[microviewName];
    };
    MicroviewSuperHostService.prototype.bootstrapMicroview = function (microviewMetadata, getLocale, startListeningToSpecificCommunicationChannels) {
        var hostService = new MicroviewHostService(microviewMetadata, getLocale, startListeningToSpecificCommunicationChannels);
        this.hostServices[microviewMetadata.name] = hostService;
    };
    MicroviewSuperHostService.instance = new MicroviewSuperHostService();
    return MicroviewSuperHostService;
}());
exports.MicroviewSuperHostService = MicroviewSuperHostService;
var MicroviewHostService = (function () {
    function MicroviewHostService(microviewMetadata, getLocale, startListeningToSpecificCommunicationChannels) {
        var _this = this;
        this.alreadyLoaded = false;
        this.locale = undefined;
        this.microviewName = microviewMetadata.name;
        if (microviewMetadata.distFolderName) {
            this.distFolderName = microviewMetadata.distFolderName;
        }
        this.getLocale = getLocale;
        this.startListeningToSpecificCommunicationChannels = startListeningToSpecificCommunicationChannels;
        this.bundleReadyPromise = new Promise(function (resolve, reject) {
            _this.loadFileResolveFunction = resolve;
            _this.loadFileRejectFunction = reject;
        });
        this.bundleReadyPromise.then(function () {
        }, function () {
            if (_this.getMicroViewDebugMode() !== MicroViewDebugModes.none) {
                console.error(_this.microviewName + 'Microview JS files fail to load.');
            }
        });
        window.addEventListener('load', function () {
            _this.bootstrapMicroView();
        });
    }
    MicroviewHostService.prototype.requestScripts = function (urls, version) {
        var _this = this;
        var promises = urls
            .map(function (url) { return url + (version ? '?version=' + version : ''); })
            .map(function (url) {
            return DOMService_1.DOMService.instance.loadScript(_this.microviewName, url);
        });
        Promise.all(promises).then(function () {
            _this.bundleReadyCommunicationChannelMessagePromise.then(function () {
                _this.loadFileResolveFunction();
            });
        }, function () {
            _this.loadFileRejectFunction();
        });
    };
    MicroviewHostService.prototype.bootstrapMicroView = function () {
        var locale = this.getLocale();
        var mode = this.getMicroViewDebugMode();
        var version = this.getMicroViewVersion(mode);
        if (!this.alreadyLoaded) {
            this.locale = locale;
            this.alreadyLoaded = true;
            console.log(this.microviewName + (" Component " + version));
            this.listenToCommunicationChannels();
            this.requestScripts(this.getUrls(mode, locale), version);
            this.setMicroViewVersion(mode);
        }
        else if (this.locale !== locale) {
            this.locale = locale;
            this.requestScripts(this.getLocaleUrls(mode, locale), version);
        }
    };
    MicroviewHostService.prototype.listenToCommunicationChannels = function () {
        var _this = this;
        this.startListeningToSpecificCommunicationChannels();
        this.bundleReadyCommunicationChannelMessagePromise = new Promise(function (resolve) {
            (new MicroViewLifecyleChannels_1.MicroViewBundleReadyChannel(_this.microviewName)).listen(function () {
                resolve();
            });
        });
    };
    MicroviewHostService.prototype.getUrls = function (mode, locale) {
        var distFolderURLName;
        if (this.distFolderName) {
            distFolderURLName = this.distFolderName;
        }
        else {
            distFolderURLName = this.microviewName;
        }
        var actualMode = mode;
        if (actualMode === MicroViewDebugModes.local && this.getLocalMicroViewNames().indexOf(this.microviewName) === -1) {
            actualMode = MicroViewDebugModes.none;
        }
        switch (actualMode) {
            case MicroViewDebugModes.none:
                return [
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/messages." + locale + ".js"),
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/formatters-and-parsers." + locale + ".js"),
                    '/content-exploration/' + this.microviewName + '/' + this.microviewName + '.min.js'
                ];
            case MicroViewDebugModes.remote:
                return [
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/messages." + locale + ".js"),
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/formatters-and-parsers." + locale + ".js"),
                    '/content-exploration/' + this.microviewName + '/' + this.microviewName + '.js'
                ];
            case MicroViewDebugModes.local:
                return [
                    "/" + distFolderURLName + ("-dist/compiled-locales/messages." + locale + ".js"),
                    "/" + distFolderURLName + ("-dist/compiled-locales/formatters-and-parsers." + locale + ".js"),
                    '/' + this.microviewName + '.js'
                ];
        }
    };
    MicroviewHostService.prototype.getLocaleUrls = function (mode, locale) {
        var distFolderURLName;
        if (this.distFolderName) {
            distFolderURLName = this.distFolderName;
        }
        else {
            distFolderURLName = this.microviewName;
        }
        var actualMode = mode;
        if (actualMode === MicroViewDebugModes.local && this.getLocalMicroViewNames().indexOf(this.microviewName) === -1) {
            actualMode = MicroViewDebugModes.none;
        }
        switch (actualMode) {
            case MicroViewDebugModes.none:
                return [
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/messages." + locale + ".js"),
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/formatters-and-parsers." + locale + ".js"),
                ];
            case MicroViewDebugModes.remote:
                return [
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/messages." + locale + ".js"),
                    "/content-exploration/" + this.microviewName + "/" + distFolderURLName + ("-dist/compiled-locales/formatters-and-parsers." + locale + ".js"),
                ];
            case MicroViewDebugModes.local:
                return [
                    "/" + distFolderURLName + ("-dist/compiled-locales/messages." + locale + ".js"),
                    "/" + distFolderURLName + ("-dist/compiled-locales/formatters-and-parsers." + locale + ".js")
                ];
        }
    };
    MicroviewHostService.prototype.getMicroViewDebugMode = function () {
        return MicroViewDebugModes[queryString.parse(Location_1.Location.instance.search())['microViewDebug']] || MicroViewDebugModes.none;
    };
    MicroviewHostService.prototype.getLocalMicroViewNames = function () {
        var localMicroViewNames = queryString.parse(Location_1.Location.instance.search())['localMicroViews'];
        return localMicroViewNames ? localMicroViewNames.split(';') : [];
    };
    MicroviewHostService.prototype.setMicroViewVersion = function (mode) {
        return __awaiter(this, void 0, void 0, function () {
            var timestamp, response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (mode === MicroViewDebugModes.local) {
                            return [2];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        timestamp = new Date().getTime().toString(36);
                        return [4, axios_1.default.get("/content-exploration/" + this.microviewName + ("/version.txt?ts=" + timestamp))];
                    case 2:
                        response = _b.sent();
                        localStorage.setItem(this.microviewName + 'Version', response.data);
                        return [3, 4];
                    case 3:
                        _a = _b.sent();
                        return [2];
                    case 4: return [2];
                }
            });
        });
    };
    MicroviewHostService.prototype.getMicroViewVersion = function (mode) {
        if (mode === MicroViewDebugModes.local) {
            return '';
        }
        var version = localStorage.getItem(this.microviewName + 'Version');
        return version || '';
    };
    return MicroviewHostService;
}());
exports.MicroviewHostService = MicroviewHostService;
//# sourceMappingURL=MicroviewHostService.js.map